import _ from 'lodash';
import ContractGenerationTractDetail from 'src/components/project/sections/LeasingComponents/redesign/ContractGenerationModels/ContractGenerationTractDetail';
import LeaseGenerationOwnerData from 'src/models/leasing/LeaseGenerationOwnerData';
import LeaseGenerationTractDetail from 'src/models/leasing/LeaseGenerationTractDetail';
import MathUtil from './MathUtil';
import IndexReferenceType from 'src/models/IndexReferenceType';
import { LandSystem } from 'src/models/LandSystem';

export default class AgreementUtil {
    // tslint:disable-next-line: no-any
    public static mapSelectedOwnerTractData(ownerData: any, tractData: LeaseGenerationOwnerData) {
        const ownerDataObj = JSON.parse(ownerData);
        console.log('from agr util', ownerDataObj);
        return 1;
    }

    public static findLeaseTractChanges(ownerTracts: ContractGenerationTractDetail[], leaseTracts: ContractGenerationTractDetail[], landSystem: LandSystem): boolean {
        if (ownerTracts.length !== leaseTracts.length) {
            return true;
        }

        let ownerTemps = ownerTracts.map(ot => {
            ot.grossAcres = ot.grossAcres > 0 ? ot.grossAcres : 0;
            ot.decimalInterest = ot.decimalInterest > 0 ? ot.decimalInterest : 0;

            return {
                section: ot.section > 0 ? ot.section.toString() : '0',
                township: landSystem === LandSystem.Eastern ? (ot.easternTownship?.length > 0 ? ot.easternTownship : '') : (ot.township?.length > 0 ? ot.township : ''),
                range: (!!ot.range && ot.range?.length > 0 && ot.range !== '0') ? ot.range : null,
                tractName: ot.tractName?.length > 0 ? ot.tractName : '',
                grossAcres: MathUtil.cleanNumber(ot.grossAcres, 4, 0),
                legalDescription: ot.legalDescription?.length > 0 ? ot.legalDescription : '',
                decimalInterest: MathUtil.cleanNumber(ot.decimalInterest, 4, 0),
                hasNEMI: ot.hasNEMI,
                ownershipId: ot.ownershipId,
                county: ot.county
            };
        });

        for (let lt of leaseTracts) {
            lt.grossAcres = lt.grossAcres > 0 ? lt.grossAcres : 0;
            lt.decimalInterest = lt.decimalInterest > 0 ? lt.decimalInterest : 0;

            let leaseTemp = {
                section: lt.section > 0 ? lt.section.toString() : '0',
                township: ((lt.township?.length > 0 && lt.township !== ' ' && lt.township !== '0') ? lt.township :
                 ((lt.easternTownship?.length > 0 && lt.easternTownship !== ' ' && lt.easternTownship !== '0' ? lt.easternTownship : '' ))),
                range: (!!lt.range && lt.range?.length > 0 && lt.range !== '0') ? lt.range : null,
                tractName: lt.tractName?.length > 0 ? lt.tractName : '',
                grossAcres: MathUtil.cleanNumber(lt.grossAcres, 4, 0),
                legalDescription: lt.legalDescription?.length > 0 ? lt.legalDescription : '',
                decimalInterest: MathUtil.cleanNumber(lt.decimalInterest, 4, 0),
                hasNEMI: lt.hasNEMI,
                ownershipId: lt.ownershipId,
                county: lt.county
            };

            let ownerTract = ownerTemps.find(ot => ot.ownershipId === leaseTemp.ownershipId);
            if (ownerTract === undefined) {
                return true;
            }

            if (!_.isEqual(ownerTract, leaseTemp)) {
                return true;
            }
        }

        return false;
    }

    // Returns Total Acreages for Generated Contract: [TotalGross, TotalNet]
    public static calcTotalAcreages = (tractList: Array<ContractGenerationTractDetail>, landSystem: LandSystem): number[] => {
        let tempTotalGrossAcres = 0;
        let tempTotalNetAcres = 0;

        let clickedTracts: Array<ContractGenerationTractDetail> = tractList?.filter((t: ContractGenerationTractDetail) => t.includeTract === true);
        let duplicates: Array<ContractGenerationTractDetail> = [];

        for (const t of clickedTracts) {
            let tNumber = t.surfaceTractNumber > 0 ? t.surfaceTractNumber : t.tractNumber;
            
            let duplicateExist: ContractGenerationTractDetail = duplicates.find(
                (d) => {
                    let dtNumber = d.surfaceTractNumber > 0 ? d.surfaceTractNumber : d.tractNumber;
                    if (landSystem === LandSystem.EastTexas) {
                        return dtNumber === tNumber;
                    }
                    return `${d.sectionNumber}.${dtNumber}` === `${t.sectionNumber}.${tNumber}`;
                }
            );

            let currentNet = parseFloat(t.decimalInterest + '') * parseFloat(t.grossAcres + '') || 0;
            
            if (!duplicateExist && !!t.includeTract) {
                // ONLY ADD GROSS IF NOT PART OF THE SAME TRACT. (DON'T DOUBLE UP WITH HORIZONS OR EXTRA OWNERSHIPS.)
                tempTotalGrossAcres += parseFloat(t.grossAcres + '') || 0;
                tempTotalNetAcres += currentNet;
                t.netAcres = currentNet;
                duplicates.push(t);
            } else if (duplicateExist.horizonNumber === t.horizonNumber) {
                // AGGREGATE NET ACRES FOR OWNERSHIPS ON THE SAME HORIZON.
                tempTotalNetAcres += currentNet;
            } else if (duplicateExist.netAcres < currentNet) {
                // SUBTRACT SMALLER NET ACREAGE IF OWNERSHIPS EXIST ACROSS MULTIPLE HORIZONS ON THE SAME TRACT.
                tempTotalNetAcres += currentNet - duplicateExist.netAcres;
            }
        }

        return [tempTotalGrossAcres, tempTotalNetAcres];
    };

    // NOTE: This has updated to the RTE box. It will no longer update the plain text Legal Description
    public static formatTractListLegal = (tractList: Array<ContractGenerationTractDetail>): string => {
        let tractNumber = 1;
        let newLegal = '';

        let clickedTracts: Array<ContractGenerationTractDetail> = tractList?.filter((t: ContractGenerationTractDetail) => t.includeTract === true);
        let filteredTracts: Array<ContractGenerationTractDetail> = AgreementUtil.tractListData(clickedTracts);

        if (filteredTracts.length === clickedTracts.length) {
            for (let ft of filteredTracts) {
                if (!!ft.includeTract) {
                    newLegal += `<p>TRACT ${tractNumber ? tractNumber : ''}: ${ft.legalDescription ? ft.legalDescription : ''} </p>`;
                    tractNumber++;
                }
            }
        } else if (filteredTracts.length !== clickedTracts.length) {
            let completeTracts: Array<ContractGenerationTractDetail> = AgreementUtil.tractListData(tractList);
            let duplicates: Array<ContractGenerationTractDetail> = [];
            for (const t of clickedTracts) {
                let inCT: ContractGenerationTractDetail = completeTracts.find(
                    (c) => `${c.sectionNumber}.${c.tractNumber}.${c.horizonNumber}` === `${t.sectionNumber}.${t.tractNumber}.${t.horizonNumber}`
                );
                let duplicateExist: ContractGenerationTractDetail = duplicates.find(
                    (d) => `${d.sectionNumber}.${d.tractNumber}.${d.horizonNumber}` === `${t.sectionNumber}.${t.tractNumber}.${t.horizonNumber}`
                );

                if (!!inCT && !duplicateExist && !!t.includeTract) {
                    newLegal += `<p>TRACT ${tractNumber ? tractNumber : ''}: ${t.legalDescription ? t.legalDescription : ''} </p>`;
                    tractNumber++;
                    duplicates.push(t);
                }

                if (!!inCT && !!duplicateExist && !!t.includeTract) {
                    newLegal += `<p>TRACT ${tractNumber ? tractNumber : ''}: ${t.legalDescription ? t.legalDescription : ''} </p>`;
                    tractNumber++;
                }

                if (!inCT && !duplicateExist && !!t.includeTract) {
                    newLegal += `<p>TRACT ${tractNumber ? tractNumber : ''}: ${t.legalDescription ? t.legalDescription : ''} </p>`;
                    tractNumber++;
                }
            }
        }

        return newLegal;
    };

    public static getGlobalId = (tractDetail: ContractGenerationTractDetail, parentTractType: string) => {
        let global = '';
        let horizonString = tractDetail.tractNumber + 'm-' + tractDetail.horizonNumber;
        let surfaceString = tractDetail.surfaceTractNumber + 's';
        let section = tractDetail.sectionNumber + '.';

        global = section;
        if (parentTractType === 'Mineral Tract') {
            global += horizonString;
            if (tractDetail.type === 'Surface') {
                global += '.' + surfaceString;
            }
        } else if (parentTractType === 'Surface Tract') {
            global += surfaceString;
            if (tractDetail.type === 'Mineral') {
                global += '.' + horizonString;
            }
        }

        return global;
    };

    public static navigateToTract = (tract: ContractGenerationTractDetail | LeaseGenerationTractDetail, tractTypeId: number, clientNumber: number, projectNumber: number) => {
        switch (tractTypeId) {
            case 1:
                return `/clients/${clientNumber}/projects/${projectNumber}/sections/${tract.sectionNumber}/tracts/${tract.tractNumber
                    }/horizons/${tract.horizonNumber > 0 ? tract.horizonNumber : 1}`;
            case 2:
                return `/clients/${clientNumber}/projects/${projectNumber}/sections/${tract.sectionNumber}/surface-tracts/${tract.surfaceTractNumber}`;
            case null:
            case 0:
                return `/clients/${clientNumber}/projects/${projectNumber}/sections/${tract.sectionNumber}/tracts/${tract.tractNumber
                    }/horizons/${tract.horizonNumber > 0 ? tract.horizonNumber : 1}`;
            default:
                return `/clients/${clientNumber}/projects/${projectNumber}/sections/${tract.sectionNumber}`;
        }
    };

    // parse the boolean value from RHFToggle
    public static parseBool = (value: string) => {
        if (value === 'true') {
            return true;
        } else if (value === 'false') {
            return false;
        }
        return null;
    };

    public static getOptions = (measurementTypes: IndexReferenceType[], type: string, item: string = '') => {
        if (measurementTypes?.length > 0) {
            return measurementTypes
                .filter((mt) => mt.description === type)
                .map((option) => {
                    if (type === 'Fee' && option.name === 'Per Item') {
                        return { value: option.id, label: `Per ${item}` };
                    }
                    return { value: option.id, label: option.name };
                });
        }
        return [];
    };

    public static convertToPlainText = (rtf: string) => {
        rtf = rtf.replace(/&nbsp;/g, ' ');
        rtf = rtf.replace(/<\/p>/g, `\n`);
        rtf = rtf.replace(/<\/[a-zA-z]+>|<[a-zA-z]+>|\&nbsp;/g, '');
        return rtf.trim();
    };

    // Private formatting methods for tract list.
    private static tractListData = (tracts: Array<ContractGenerationTractDetail>) => {
        if (tracts?.length > 0) {
            let globalIds: string[] = tracts?.map((t) => {
                return `${t.sectionNumber}.${t.tractNumber}`;
            });
            let mineralTracts = tracts.filter(t => t.horizonNumber > 0);

            let correctTracts: Array<ContractGenerationTractDetail> = AgreementUtil.finalTractList(mineralTracts, globalIds);

            return correctTracts;
        }
        return [];
    };

    private static finalTractList = (tracts: Array<ContractGenerationTractDetail>, ids: Array<string>) => {
        let finalTracts: Array<ContractGenerationTractDetail> = [];
        let singles: Array<ContractGenerationTractDetail> = [];
        let tractsToBeRender: Array<ContractGenerationTractDetail> = [];

        for (let i = 0; i < ids.length; i++) {
            let filteredTracts: Array<ContractGenerationTractDetail> = tracts.filter((t) => `${t.sectionNumber}.${t.tractNumber}` === ids[i]);
            let itemExist: ContractGenerationTractDetail = finalTracts?.find(
                (tt: ContractGenerationTractDetail) =>
                    `${tt?.sectionNumber}.${tt?.tractNumber}` === `${tracts[i]?.sectionNumber}.${tracts[i]?.tractNumber}`
            );

            if (filteredTracts.length > 1 && !itemExist) {
                finalTracts = finalTracts.concat(AgreementUtil.tractCorrection(filteredTracts));
            }

            if (filteredTracts.length === 1) {
                singles.push(...filteredTracts);
            }
        }

        if (singles.length >= 1) {
            tractsToBeRender.push(...finalTracts);
            tractsToBeRender.push(...singles);
        } else {
            tractsToBeRender = finalTracts;
        }

        return tractsToBeRender;
    };

    // Function to remove duplicates based on global id
    private static tractCorrection = (duplicates: Array<ContractGenerationTractDetail>) => {
        let decimalInterestValues: Array<number> = duplicates.map((dt) => {
            return dt.decimalInterest;
        });

        let tractsToKeep: Array<ContractGenerationTractDetail> = [];

        let highestDI = Math.max(...decimalInterestValues);
        let lowestDI = Math.min(...decimalInterestValues);

        if (highestDI === lowestDI) {
            let tracts: ContractGenerationTractDetail = duplicates[0];
            tractsToKeep.push(tracts);
        } else {
            let tracts: ContractGenerationTractDetail = duplicates.find((d) => parseFloat(d.decimalInterest + '') === highestDI);
            tractsToKeep.push(tracts);
        }

        return tractsToKeep;
    };
}



// WEBPACK FOOTER //
// ./src/util/AgreementUtil.ts